import { isEmpty } from 'lodash-es';
import _ from 'lodash';

const BASE_PATH = '/api/v1';

const INFLUENCERS_PATH = `${BASE_PATH}/influencers`;
const AGENTS_PATH = `${BASE_PATH}/clients`;
const MANAGER_PATH = `/manager`;

const MANAGER_ROUTES = {
  LAB_LIST_POSTS: 'lab_list_posts'
}

export const AGENTS_ENDPOINTS = {
  SIGN_OUT: `${AGENTS_PATH}/agents/sign_out`,
  CONTENT: {
    PURCHASED: (accountId) => `${AGENTS_PATH}/accounts/${accountId}/purchased_contents`
  },
  CONTENT_APPROVAL: {
    OFFER: {
      USERS: (offerId, params) => handleEndpoint(
        `${AGENTS_PATH}/offers/${offerId}/content_approval/users`, params
      ),
      USER_POST_DRAFTS: (offerId, params) => handleEndpoint(
        `${AGENTS_PATH}/offers/${offerId}/content_approval/user_post_drafts`, params
      ),
      USER_POST_DRAFT_MESSAGE_CREATE: (campaignId, params) => handleEndpoint(
        `${AGENTS_PATH}/offers/${offerId}/content_approval/user_post_drafts/conversation_message`, params
      ),
      USER_POST_DRAFTS_MESSAGE_DELETE: (campaignId, params) => handleEndpoint(
        `${AGENTS_PATH}/offers/${offerId}/content_approval/user_post_drafts/conversation_message_delete`, params
      )
    },
    CAMPAIGN: {
      USERS: (campaignId, params) => handleEndpoint(
        `${AGENTS_PATH}/campaigns/${campaignId}/content_approval/users`, params
      ),
      USER_POST_DRAFT: (campaignId, userPostDraftId, params) => handleEndpoint(
        `${AGENTS_PATH}/campaigns/${campaignId}/content_approval/user_post_drafts/${userPostDraftId}`, params
      ),
      USER_POST_DRAFTS: (campaignId, params) => handleEndpoint(
        `${AGENTS_PATH}/campaigns/${campaignId}/content_approval/user_post_drafts`, params
      ),
      USER_POST_DRAFT_MESSAGE_CREATE: (campaignId, params) => handleEndpoint(
        `${AGENTS_PATH}/campaigns/${campaignId}/content_approval/user_post_drafts/conversation_message`, params
      ),
      USER_POST_DRAFTS_MESSAGE_DELETE: (campaignId, params) => handleEndpoint(
        `${AGENTS_PATH}/campaigns/${campaignId}/content_approval/user_post_drafts/conversation_message_delete`, params
      )
    },
    USER_OFFER: {
      USER_POST_DRAFTS: (campaignId, userOfferId, params) => handleEndpoint(
        `${AGENTS_PATH}/campaigns/${campaignId}/user_offers/${userOfferId}/user_post_drafts`, params
      )
    },
  },
  CAMPAIGN: {
    GET: (accountId) => `${AGENTS_PATH}/campaigns/${accountId}`,
    VETTING_USER: (campaignId, userId) => `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users/${userId}`,
    VETTING: (campaignId, params = {}) => {
      const endpoint = `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users`;
      if (isEmpty(params)) { return endpoint; }
      const queryString = formatParams(params);
      if (isEmpty(queryString)) { return endpoint; }
      return `${endpoint}?${queryString}`;
    },
    CONTENT_APPROVAL: (campaignId, params = {}) => {
      const endpoint = `${AGENTS_PATH}/campaigns/${campaignId}/content_approval/user_post_drafts`;
      if (isEmpty(params)) return endpoint;
      const queryString = formatParams(params);
      if (isEmpty(queryString)) { return endpoint; }
      return `${endpoint}?${queryString}`;
    },
    REPORTING: (params) => handleEndpoint(`${AGENTS_PATH}/dashboard/show`, params),
    REPORTING_POSTS: (params) => handleEndpoint(`${AGENTS_PATH}/reporting/posts`, params),
    REPORTING_STORIES: (params) => handleEndpoint(`${AGENTS_PATH}/reporting/stories`, params),
    REPORTING_UPDATE_POST: (userPostId) => `${AGENTS_PATH}/reporting/update_post/${userPostId}`,

    CLICKS: (campaignId) => `${AGENTS_PATH}/campaigns/${campaignId}/clicks`,
    FINALIZE_VETTING: (campaignId) => `${AGENTS_ENDPOINTS.CAMPAIGN.VETTING(campaignId)}/finalize_vetted_list`,
    PARTICIPANTS: (campaignId) => `${AGENTS_PATH}/campaigns/${campaignId}/participants`,
    PARTICIPANTS_TABLE: (campaignId, offerId) => `${AGENTS_PATH}/campaigns/${campaignId}/participants_table${offerId ? `?offer_id=${offerId}` : ''}`,
    PARTICIPANTS_TABLE_DOWNLOAD: (campaignId, offerId) => `/agents/campaigns/${campaignId}/to_participants_table_csv${offerId ? `?offer_id=${offerId}` : ''}`,
    USER_POST: (campaignId, userPostId, params) => handleEndpoint(
      `${AGENTS_PATH}/campaigns/${campaignId}/user_posts/${userPostId}`, params
    ),
    VETTING_TABLE: (campaignId, offerId) => `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users_table${offerId ? `?offer_id=${offerId}` : ''}`,
    VETTING_USER_MESSAGES: (campaignId, vettingUserId, params) => handleEndpoint(
      `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users/${vettingUserId}/conversation`, params
    ),
    VETTING_USER_MESSAGE: (campaignId, vettingUserId) => `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users/${vettingUserId}/conversation`,
    VETTING_USER_MESSAGE_CREATE: (campaignId, vettingUserId) => `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users/${vettingUserId}/conversation_message`,
    VETTING_USERS_MESSAGE_DELETE: (campaignId, vettingUserId) => `${AGENTS_PATH}/campaigns/${campaignId}/vetting_users/${vettingUserId}/conversation_message_delete`
  },
  OFFER: {
    VETTING_USER: (offerId, userId) => `${AGENTS_PATH}/offers/${offerId}/vetting_users/${userId}`,
    VETTING: (offerId, params = {}) => {
      const endpoint = `${AGENTS_PATH}/offers/${offerId}/vetting_users`;
      if (isEmpty(params)) { return endpoint; }
      const queryString = formatParams(params);
      if (isEmpty(queryString)) { return endpoint; }
      return `${endpoint}?${queryString}`;
    },
    PARTICIPANTS: (offerId) => `${AGENTS_PATH}/offers/${offerId}/participants`,
    CONTENT_APPROVAL: (offerId, params = {}) => {
      const endpoint = `${AGENTS_PATH}/offers/${offerId}/content_approval/user_post_drafts`;
      if (isEmpty(params)) return endpoint;
      const queryString = formatParams(params);
      if (isEmpty(queryString)) { return endpoint; }
      return `${endpoint}?${queryString}`;
    },
    REPORTING: (params) => handleEndpoint(`${AGENTS_PATH}/dashboard/show`, params),
    CLICKS: (offerId) => `${AGENTS_PATH}/offers/${offerId}/clicks`,
    VETTING_USER_MESSAGES: (offerId, vettingUserId, params) => handleEndpoint(
      `${AGENTS_PATH}/offers/${offerId}/vetting_users/${vettingUserId}/conversation`, params
    ),
    VETTING_USER_MESSAGE: (offerId, vettingUserId) => `${AGENTS_PATH}/offers/${offerId}/vetting_users/${vettingUserId}/conversation`,
    VETTING_USER_MESSAGE_CREATE: (offerId, vettingUserId) => `${AGENTS_PATH}/offers/${offerId}/vetting_users/${vettingUserId}/conversation_message`,
    VETTING_USERS_MESSAGE_DELETE: (offerId, vettingUserId) => `${AGENTS_PATH}/offers/${offerId}/vetting_users/${vettingUserId}/conversation_message_delete`
  },
  USER_POSTS: {
    PAGE: (page) => `${AGENTS_PATH}/accounts/user_posts?page=${page}`
  },
  CART_LINE_ITEMS: `${AGENTS_PATH}/cart_line_items`,
  DASHBOARD: {
    GET: `${AGENTS_PATH}/dashboard`,
    HEADER_POSTS: (accountId) => `${AGENTS_PATH}/dashboard/header_posts?account_id=${accountId}`,
    NETWORK_STATS: (accountId) => `${AGENTS_PATH}/dashboard/network_stats?account_id=${accountId}`
  },
  CART: {
    GET: `${AGENTS_PATH}/cart`,
    POST: `${AGENTS_PATH}/cart`,
  },
  COUNTRIES: `${BASE_PATH}/countries`,
  PROFILE: {
    EDIT: '/profile/edit',
  },
  INFLUENCER_USERS: {
    GET: (userId) => `${AGENTS_PATH}/users/${userId}`,
  },
  VETTING_USERS: {
    PAST_ACTIVITY: (id) => `${AGENTS_PATH}/vetting_users/${id}/past_activity`,
    STATUS_UPDATE: (id, params) => handleEndpoint(`${AGENTS_PATH}/vetting_users/${id}/status_update`, params),
  },
  NETWORK_LISTS: `${AGENTS_PATH}/dashboard/network_lists`, // TODO: refactor
  NETWORK_LIST: (networkList) => `${AGENTS_PATH}/dashboard/network_lists/${networkList}`,
  NETWORK_LIST_TABLE_DETAILS: (networkList) => `${AGENTS_ENDPOINTS.NETWORK_LIST(networkList)}/table_details`,
  NETWORK_LIST_ACTIONS: (networkAction, params) => handleEndpoint(`${AGENTS_PATH}/network_lists/actions/${networkAction}`, params),
  REPORTING_OFFER_GROUP: {
    GET: (offerGroupId, params = {}) => {
      const endpoint = `${AGENTS_PATH}/reporting_offer_groups/${offerGroupId}`;
      if (isEmpty(params)) { return endpoint; }
      const queryString = new URLSearchParams(params).toString();
      return `${endpoint}?${queryString}`;
    },
    CLICKS: (offerGroupId) => `${AGENTS_PATH}/reporting_offer_groups/${offerGroupId}/clicks`,
    REPORTING: (params) => handleEndpoint(`${AGENTS_PATH}/dashboard/show`, params),
  },
  USERS: {
    HASHTAGS: (userId, platform) =>
      `${AGENTS_PATH}/users/${userId}/hashtags?platform=${platform}`
  },
  SOCIAL_PLATFORM_POSTS: (userId, platform, quantity) => `${AGENTS_PATH}/users/${userId}/social_posts_profiles?platform=${platform}&quantity=${quantity}`,
  ACCOUNT_EMBEDDED_REPORTS: {
    GET: `${AGENTS_PATH}/accounts/embedded_reports`
  },
  S3: {
    POST: `${AGENTS_PATH}/s3_image`
  },
  USER_OFFERS: {
    APPLY_ACTION: (id, actionType) => `${AGENTS_PATH}/user_offers/${id}/apply_action/${actionType}.json`,
  },
  FORCE_RELOAD_STATUS: `${AGENTS_PATH}/clients/force_reload_status`,
  CONTENT_CLOUD: {
    POSTS: (params) => handleEndpoint(`${AGENTS_PATH}/accounts/content_cloud/posts`, params),
    CAMPAIGNS: `${AGENTS_PATH}/accounts/content_cloud/campaigns`
  },
  MEDIA: {
    GET: (type, id) => `${AGENTS_PATH}/media/download?object_type=${type}&object_id=${id}`
  },
};

export const INFLUENCERS_ENDPOINTS = {
  USER_POST_DRAFTS_MEDIA: {
    GET: (userPostDraftId) => `${INFLUENCERS_PATH}/user_post_drafts/${userPostDraftId}/media`
  },
  USERS: {
    TIPALTI_IFRAME: (language) => `${INFLUENCERS_PATH}/users/tipalti_iframe?locale=${language}`,
    PUT: (userId) => `${INFLUENCERS_PATH}/users/${userId}`
  },
  OFFERS: {
    USER_OFFERS: {
      POST: (offerId) => `${INFLUENCERS_PATH}/offers/${offerId}/user_offers`,
      PATCH: (userOfferId) => `${INFLUENCERS_PATH}/user_offers/${userOfferId}`,
    },
    USER_POSTS: {
      PATCH: (offerId, userPostId) => `${INFLUENCERS_PATH}/offers/${offerId}/user_posts/${userPostId}`,
    }
  },
  USER_POST_DRAFTS: {
    GET: (params) => handleEndpoint(`${INFLUENCERS_PATH}/user_post_drafts`, params)
  },
  PAGINATED_USER_POST: {
    GET: (userOfferId, params) => handleEndpoint(`${INFLUENCERS_PATH}/user_offers/${userOfferId}/user_posts/paginated_user_posts`, params)
  },
  USER_OFFERS: (userOfferId) => `${INFLUENCERS_PATH}/user_offers/${userOfferId}`,
  SOCIAL_PLATFORM_POSTS: (platform, quantity) =>
    `${INFLUENCERS_PATH}/social_profiles/social_posts?platform=${platform}&quantity=${quantity}`,
  FORCE_RELOAD_STATUS: `${INFLUENCERS_PATH}/influencers/force_reload_status`,
  ALLOW_PRE_REGISTERED_USER: (token) => `${INFLUENCERS_PATH}/welcome/${token}`
};

export const INTERNAL_ENDPOINTS = {
  COLLECTIVES: `${BASE_PATH}/internal/collectives`,
  COLLECTIVE_STATUS_COUNTS: `${BASE_PATH}/internal/collectives/status_counts`,
  COLLECTIVE_STATS: (collectiveId) => `${BASE_PATH}/internal/collectives/${collectiveId}/stats`,
  COLLECTIVE_USERS: (collectiveId) => `${BASE_PATH}/internal/collectives/${collectiveId}/collective_users`,
  COLLECTIVE_USER_SHOW: (collectiveId, userId) => `${BASE_PATH}/internal/collectives/${collectiveId}/users/${userId}`,
  COLLECTIVE_USER_UPDATE_REVIEW: (collectiveId, userId) =>
    `${BASE_PATH}/internal/collectives/${collectiveId}/users/${userId}/update_review`,
COLLECTIVE_ASSIGN_GROUPS: (collectiveId) => `${BASE_PATH}/internal/collectives/${collectiveId}/assign_groups`,
  COLLECTIVE_ASSIGN_GROUPS_STATUS: (collectiveId) => `${BASE_PATH}/internal/collectives/${collectiveId}/assign_groups_status`,
  PAYMENT_UPLOADS_MARK_AS_PAID: `${BASE_PATH}/internal/payment_uploads/mark_as_paid`,
};

export const MANAGER_ENDPOINTS = {
  LAB_LIST_POSTS: {
    GET: (params) => handleEndpoint(`${MANAGER_PATH}/${MANAGER_ROUTES.LAB_LIST_POSTS}/platform_posts`, params)
  },
  VETTING_USERS: {
    PAST_ACTIVITY: (id) => `${MANAGER_PATH}/vetting_users/${id}/past_activity`,
  },
  CAMPAIGNS: {
    AI_SIGNAL_DETECTION: {
      URL: (campaignId) => `${MANAGER_PATH}/campaigns/${campaignId}/video_analysis_signals`,
      DELETE: (campaignId, signalId) => (
        `${MANAGER_ENDPOINTS.CAMPAIGNS.AI_SIGNAL_DETECTION.URL(campaignId)}/${signalId}`
      ),
      DELETE_ALL: (campaignId) => (
        `${MANAGER_ENDPOINTS.CAMPAIGNS.AI_SIGNAL_DETECTION.URL(campaignId)}/delete_all`
      ),
    }
  }
};

const handleEndpoint = (endpoint, params = {}) => {
  if (isEmpty(params)) { return endpoint; }
  const queryString = formatParams(params);
  return `${endpoint}?${queryString}`;
};

const formatParams = (data) => {
  const params = new URLSearchParams();

  _.map(data, (value, key) => {
    if (Array.isArray(data[key])) {
      _.map(value, item => params.append(`${key}[]`, item));
    } else if (value) {
      params.append(key, value);
    }
  });

  return params.toString();
};
